<template>
  <div class="relative w-32 h-32 mx-auto">
    <svg class="transform -rotate-90 w-32 h-32">
      <circle
        cx="64"
        cy="64"
        r="56"
        stroke="currentColor"
        stroke-width="4"
        fill="transparent"
        class="text-gray-200"
      />
      <circle
        cx="64"
        cy="64"
        r="56"
        stroke="currentColor"
        stroke-width="4"
        fill="transparent"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
        class="text-rogue-vibrant-green transition-all duration-500 ease-out"
        stroke-linecap="round"
      />
    </svg>
    
    <!-- Center content -->
    <div class="absolute inset-0 flex items-center justify-center">
      <div class="text-center">
        <div class="text-2xl font-bold text-rogue-deep-forest">
          {{ displayValue }}
        </div>
        <div class="text-xs text-gray-500">
          {{ label }}
        </div>
      </div>
    </div>
    
    <!-- Milestone celebration -->
    <Transition name="celebration">
      <div v-if="showMilestone" class="absolute inset-0 flex items-center justify-center">
        <div class="text-4xl animate-bounce">🎉</div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'

const props = defineProps({
  progress: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0 && value <= 100
  },
  showMilestone: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: 'facts'
  },
  max: {
    type: Number,
    default: 7
  }
})

const emit = defineEmits(['milestone-reached'])

const circumference = computed(() => 2 * Math.PI * 56)
const strokeDashoffset = computed(() => {
  return circumference.value - (props.progress / 100) * circumference.value
})

const displayValue = computed(() => {
  return Math.round((props.progress / 100) * props.max)
})

// Watch for milestone achievements
watch(() => props.progress, (newProgress, oldProgress) => {
  const milestones = [42.86, 71.43, 100] // 3/7, 5/7, 7/7
  
  milestones.forEach(milestone => {
    if (oldProgress < milestone && newProgress >= milestone) {
      emit('milestone-reached', Math.round((milestone / 100) * props.max))
    }
  })
})
</script>

<style scoped>
.celebration-enter-active {
  transition: all 0.3s ease-out;
}

.celebration-leave-active {
  transition: all 0.3s ease-in;
}

.celebration-enter-from,
.celebration-leave-to {
  opacity: 0;
  transform: scale(0.5);
}
</style>